import axios from "axios";
import { getBackendUrl } from "../config";

const api = axios.create({
	baseURL: getBackendUrl(),
	withCredentials: true,
});

// Interceptor para depurar URLs e identificar o erro "Invalid URL"
api.interceptors.request.use(
	config => {
		const isAbsolute = config.url.startsWith("http");
		const fullUrl = isAbsolute ? config.url : (config.baseURL ? `${config.baseURL}${config.url}` : config.url);

		console.log(`[API Request] ${config.method.toUpperCase()} ${fullUrl}`, {
			url: config.url,
			baseURL: config.baseURL,
			isAbsolute
		});
		return config;
	},
	error => {
		console.error("[API Request Error]", error);
		return Promise.reject(error);
	}
);

console.log("API Base URL:", api.defaults.baseURL);

export default api;
